import { requestServices } from 'repos';
import { getResult } from 'helpers/request';
import { merchantService } from 'packages/request/clients';

const { merchantOnboard } = requestServices;

const changeTidServiceStatus = (tidServiceId: number, params: any) => {
  return merchantOnboard
    .put(`/terminal-services/change-status/${tidServiceId}`, params)
    .then(getResult);
};

const updateTidService = (tidId: number, params: any) => {
  return merchantOnboard
    .put(`/terminal-services/${tidId}`, params)
    .then(getResult);
};

const updateTidServiceWithoutNoti = (tidId: number, params: any) => {
  return merchantService
    .put(`/terminal-services/${tidId}`, params)
    .then(getResult);
};

export default {
  changeTidServiceStatus,
  updateTidService,
  updateTidServiceWithoutNoti,
};
